// import React, { useState, useEffect, useCallback } from "react";
// import axios from "axios";
// import { useParams, useNavigate, useLocation } from "react-router-dom";
// import {
//   Container,
//   Typography,
//   TextField,
//   Button,
//   Paper,
//   Box,
//   MenuItem,
//   Select,
//   FormControl,
//   InputLabel,
//   List,
//   ListItem,
//   ListItemText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress,
//   Divider,
//   Chip,
//   Avatar,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import {
//   ArrowBack,
//   Add,
//   Delete,
//   MedicalServices,
//   Healing,
//   Description,
//   MonetizationOn,
// } from "@mui/icons-material";
// import { styled } from "@mui/material/styles";

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   marginTop: theme.spacing(2),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
// }));

// const useDebounce = (value, delay) => {
//   const [debouncedValue, setDebouncedValue] = useState(value);

//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedValue(value);
//     }, delay);

//     return () => {
//       clearTimeout(handler);
//     };
//   }, [value, delay]);

//   return debouncedValue;
// };

// const AddRecord = () => {
//   const { patientId } = useParams();
//   const Name = localStorage.getItem("Name");
//   const location = useLocation();
//   const { appoinmentid, channelnumber, MTD_APPOINMENT_ID, serialNumber } = location.state || {};
//   const [searchResults, setSearchResults] = useState([]);
//   const [patientError, setPatientError] = useState("");
//   const [patientdetails, setPatientdetails] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const role = localStorage.getItem("Role");
//   const [activePrescriptionIndex, setActivePrescriptionIndex] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalContent, setModalContent] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");

//   // Cache for medicines data
//   const [medicineCache, setMedicineCache] = useState(null);
//   const [searchQuery, setSearchQuery] = useState("");
//   const debouncedSearchQuery = useDebounce(searchQuery, 300);
//   const [fetchLoading, setFetchLoading] = useState(false); // Separate loading for data fetch

//   const [prescriptions, setPrescriptions] = useState([
//     {
//       MDD_MATERIAL_CODE: "",
//       MDD_MATERIAL_NAME: "",
//       MDD_DOSAGE: "",
//       MDD_TAKES: "Daily",
//       MDD_TAKES_CUSTOM: "",
//       MDD_QUANTITY: "",
//       MMC_RATE: 0,
//     },
//   ]);

//   const [formData, setFormData] = useState({
//     MTD_PATIENT_CODE: patientId,
//     MTD_DATE: new Date().toISOString(),
//     MTD_TYPE: "",
//     MTD_DOCTOR: Name || "",
//     MTD_COMPLAIN: "",
//     MTD_DIAGNOSTICS: "",
//     MTD_REMARKS: "",
//     MTD_AMOUNT: "",
//     MTD_PAYMENT_STATUS: "",
//     MTD_TREATMENT_STATUS: "P",
//     MTD_SMS_STATUS: "",
//     MTD_SMS: "",
//     MTD_MEDICAL_STATUS: "",
//     MTD_STATUS: "",
//     MTD_CREATED_BY: Name || "",
//     MTD_CREATED_DATE: new Date().toISOString(),
//     MTD_UPDATED_BY: "",
//     MTD_CHANNEL_NO: channelnumber || null,
//     MTD_UPDATED_DATE: null,
//     MTD_APPOINMENT_ID: MTD_APPOINMENT_ID || appoinmentid || null,
//   });

//   // Search medicines function
//   const searchMedicines = useCallback(async (query) => {
//     if (!query || query.length < 3) {
//       setSearchResults([]);
//       return;
//     }

//     try {
//       let medicines = medicineCache;

//       // Fetch medicines if not cached
//       if (!medicines) {
//         const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Material`);
//         medicines = response.data;
//         setMedicineCache(medicines);
//       }

//       const q = query.toLowerCase();
//       const filtered = medicines.filter(
//         (medicine) =>
//           medicine.MMC_DESCRIPTION?.toLowerCase().includes(q) ||
//           medicine.MMC_MATERIAL_SPEC?.toLowerCase().includes(q)
//       );

//       setSearchResults(filtered);
//     } catch (error) {
//       console.error("Error fetching materials:", error);
//       setSearchResults([]);
//     }
//   }, [medicineCache]);

//   // Effect for debounced search
//   useEffect(() => {
//     if (debouncedSearchQuery) {
//       searchMedicines(debouncedSearchQuery);
//     } else {
//       setSearchResults([]);
//     }
//   }, [debouncedSearchQuery, searchMedicines]);

//   const handleFormChange = (e) => {
//     const { name, value, id } = e.target;
//     const fieldName = name || id;

//     setFormData((prevData) => ({
//       ...prevData,
//       [fieldName]: value,
//     }));
//   };

//   const handlePrescriptionChange = (index, event) => {
//     const { name, value } = event.target;
//     const values = [...prescriptions];

//     if (name === "MDD_TAKES") {
//       values[index][name] = value;
//       if (value !== "other") {
//         values[index].MDD_TAKES_CUSTOM = "";
//       }
//     } else if (name === "MDD_TAKES_CUSTOM") {
//       values[index][name] = value;
//     } else {
//       values[index][name] = value;
//     }

//     setPrescriptions(values);

//     // const isCompleted =
//     //   values[index].MDD_MATERIAL_NAME &&
//     //   values[index].MDD_TAKES &&
//     //   (values[index].MDD_TAKES !== "other" || values[index].MDD_TAKES_CUSTOM) &&
//     //   values[index].MDD_QUANTITY;

//     // if (isCompleted && index === prescriptions.length - 1) {
//     //   handleAddPrescription();
//     // }
//   };

//   const handleSearchChange = (index, event) => {
//     const query = event.target.value;
//     const values = [...prescriptions];
//     values[index].MDD_MATERIAL_NAME = query;
//     setPrescriptions(values);
//     setSearchQuery(query);
//     setActivePrescriptionIndex(index);
//   };

//   const handleAddPrescription = () => {
//     setPrescriptions([
//       ...prescriptions,
//       {
//         MDD_MATERIAL_CODE: "",
//         MDD_MATERIAL_NAME: "",
//         MDD_DOSAGE: "",
//         MDD_TAKES: "",
//         MDD_TAKES_CUSTOM: "",
//         MDD_QUANTITY: "",
//         MMC_RATE: 0,
//       },
//     ]);
//   };

//   const handleSelectMedicine = (index, materialCode, materialName, rate) => {
//     const values = [...prescriptions];
//     values[index].MDD_MATERIAL_CODE = materialCode;
//     values[index].MDD_MATERIAL_NAME = materialName;
//     values[index].MMC_RATE = rate;
//     setSearchResults([]);
//     setSearchQuery("");
//     setPrescriptions(values);
//   };

//   const handleRemovePrescription = async (index) => {
//     const values = [...prescriptions];
//     const removedPrescription = values[index];
//     values.splice(index, 1);
//     setPrescriptions(values);

//     if (isEditMode && removedPrescription.MDD_MATERIAL_CODE) {
//       try {
//         await axios.put(
//           `${process.env.REACT_APP_API_BASE_URL}/Drug/drugstatusupdate`,
//           null,
//           {
//             params: {
//               patientCode: removedPrescription.MDD_PATIENT_CODE,
//               serialNo: removedPrescription.MDD_SERIAL_NO,
//               materialCode: removedPrescription.MDD_MATERIAL_CODE,
//             },
//           }
//         );
//         console.log('Medicine status updated to "I"');
//       } catch (error) {
//         console.error("Error updating medicine status:", error);
//       }
//     }
//   };

//   // FIXED: Enhanced data fetching for edit mode
// useEffect(() => {
//   window.scrollTo(0, 0);

//   const fetchExistingData = async () => {
//     if (serialNumber) {
//       setIsEditMode(true);
//       setFetchLoading(true); // Set loading state
//       console.log("Fetching data for edit mode:", { patientId, serialNumber });

//       try {
//         // Fetch treatment details
//         const treatmentResponse = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/Treatment/patientdetail/treatmentdetail/${patientId}/${serialNumber}`
//         );

//         console.log("Treatment API Response:", treatmentResponse.data);
//         const treatmentData = treatmentResponse.data;

//         // Update form data with existing treatment information
//         setFormData(prevData => ({
//           ...prevData,
//           MTD_DOCTOR: treatmentData.MTD_DOCTOR || Name || "",
//           MTD_TYPE: treatmentData.MTD_TYPE || "",
//           MTD_COMPLAIN: treatmentData.MTD_COMPLAIN || "",
//           MTD_DIAGNOSTICS: treatmentData.MTD_DIAGNOSTICS || "",
//           MTD_REMARKS: treatmentData.MTD_REMARKS || "",
//           MTD_AMOUNT: treatmentData.MTD_AMOUNT || "",
//           MTD_TREATMENT_STATUS: treatmentData.MTD_TREATMENT_STATUS || "P",
//           MTD_DATE: treatmentData.MTD_DATE || new Date().toISOString(),
//         }));

//         // Fetch prescriptions
//         try {
//           const prescriptionsResponse = await axios.get(
//             `${process.env.REACT_APP_API_BASE_URL}/Drug/${serialNumber}`
//           );
//           console.log("Prescriptions API Response:", prescriptionsResponse.data);

//           if (prescriptionsResponse.data && prescriptionsResponse.data.length > 0) {
//             const formattedPrescriptions = prescriptionsResponse.data.map(prescription => ({
//               MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE || "",
//               MDD_MATERIAL_NAME: prescription.MDD_MATERIAL_NAME || prescription.MMC_DESCRIPTION || "",
//               MDD_DOSAGE: prescription.MDD_DOSAGE || "",
//               MDD_TAKES: prescription.MDD_TAKES || "Daily",
//               MDD_TAKES_CUSTOM: prescription.MDD_TAKES === "other" ? prescription.MDD_TAKES : "",
//               MDD_QUANTITY: prescription.MDD_QUANTITY?.toString() || "1",
//               MMC_RATE: prescription.MMC_RATE || prescription.MDD_RATE || 0,
//               MDD_SERIAL_NO: prescription.MDD_SERIAL_NO,
//               MDD_PATIENT_CODE: prescription.MDD_PATIENT_CODE,
//             }));
//             setPrescriptions(formattedPrescriptions);
//           } else {
//             // If no prescriptions, start with one empty prescription
//             setPrescriptions([{
//               MDD_MATERIAL_CODE: "",
//               MDD_MATERIAL_NAME: "",
//               MDD_DOSAGE: "",
//               MDD_TAKES: "Daily",
//               MDD_TAKES_CUSTOM: "",
//               MDD_QUANTITY: "",
//               MMC_RATE: 0,
//             }]);
//           }
//         } catch (prescriptionError) {
//           console.error("Error fetching prescriptions:", prescriptionError);
//           setSnackbarMessage("Error loading prescriptions, but you can continue editing.");
//           setSnackbarSeverity("warning");
//           setSnackbarOpen(true);
//         }

//       } catch (error) {
//         console.error("Error fetching treatment data:", error);
//         setPatientError("Unable to load treatment details.");
//         setSnackbarMessage("Failed to load existing treatment data.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       } finally {
//         setFetchLoading(false); // Clear loading state
//       }
//     }
//   };

//   fetchExistingData();
// }, [serialNumber, patientId, Name]);

// //   const handleSubmit = async (e) => {
// //   e.preventDefault();
// //   setLoading(true);
// //   const preparedPrescriptions = prescriptions.map((prescription) => ({
// //     ...prescription,
// //     MDD_TAKES:
// //       prescription.MDD_TAKES === "other"
// //         ? prescription.MDD_TAKES_CUSTOM
// //         : prescription.MDD_TAKES,
// //   }));
// //   try {
// //     if (isEditMode) {
// //        try {
// //           const updatePayload = {
// //             Treatment: {
// //               MTD_DOCTOR: formData.MTD_DOCTOR,
// //               MTD_TYPE: formData.MTD_TYPE,
// //               MTD_COMPLAIN: formData.MTD_COMPLAIN,
// //               MTD_DIAGNOSTICS: formData.MTD_DIAGNOSTICS,
// //               MTD_REMARKS: formData.MTD_REMARKS,
// //               MTD_AMOUNT: formData.MTD_AMOUNT,
// //               MTD_UPDATED_BY: Name,
// //               MTD_TREATMENT_STATUS: formData.MTD_TREATMENT_STATUS,
// //             },
// //             Drugs: preparedPrescriptions.map((prescription) => ({
// //               MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE,
// //               MDD_QUANTITY: parseInt(prescription.MDD_QUANTITY) || 0,
// //               MDD_RATE: prescription.MMC_RATE || prescription.MDD_RATE,
// //               MDD_AMOUNT:
// //                 (parseFloat(prescription.MDD_RATE) || 0) *
// //                 (parseInt(prescription.MDD_QUANTITY) || 0) ||
// //                 parseFloat(prescription.MMC_RATE) ||
// //                 0,
// //               MDD_DOSAGE: "",
// //               MDD_TAKES: prescription.MDD_TAKES,
// //               MDD_GIVEN_QUANTITY: 0,
// //               MDD_STATUS: "",
// //             })),
// //           };

// //           const response = await axios.post(
// //             `${process.env.REACT_APP_API_BASE_URL}/Treatment/updatingtreatment/${patientId}/${serialNumber}`,
// //             updatePayload
// //           );

// //           if (response.status === 200) {
// //             setSnackbarMessage("Treatment updated successfully!");
// //             setSnackbarSeverity("success");
// //             setSnackbarOpen(true);
// //             // Navigate back after a short delay to allow the snackbar to be seen
// //             setTimeout(() => {
// //               navigate(-1); // Go back one step in history
// //             }, 1500);
// //           } else {
// //             setSnackbarMessage("Failed to update treatment.");
// //             setSnackbarSeverity("error");
// //             setSnackbarOpen(true);
// //           }
// //         } catch (error) {
// //           setSnackbarMessage(
// //             error.response?.data?.message || "Error updating treatment"
// //           );
// //           setSnackbarSeverity("error");
// //           setSnackbarOpen(true);
// //         }
// //     } else {
// //       // Create new treatment
// //       const treatmentResponse = await axios.post(
// //         `${process.env.REACT_APP_API_BASE_URL}/Treatment`,
// //         {
// //           ...formData,
// //           MTD_APPOINMENT_ID: formData.MTD_APPOINMENT_ID || null
// //         }
// //       );
// //       // Extract the serial number from the response
// //       const serial_no = treatmentResponse.data.SerialNo || treatmentResponse.data.MTD_SERIAL_NO;
// //       if (!serial_no) {
// //         throw new Error("Serial number not received from treatment creation");
// //       }
// //       // Create prescriptions if any
// //       if (
// //         preparedPrescriptions.length > 0 &&
// //         preparedPrescriptions.some(
// //           (prescription) => prescription.MDD_MATERIAL_CODE
// //         )
// //       ) {
// //         const drugDetailsPromises = preparedPrescriptions.map(
// //           (prescription) => {
// //             if (prescription.MDD_MATERIAL_CODE) {
// //               if (
// //                 !prescription.MDD_MATERIAL_CODE ||
// //                 !prescription.MDD_TAKES ||
// //                 !prescription.MDD_QUANTITY
// //               ) {
// //                 setSnackbarMessage("All drug details are required.");
// //                 setSnackbarSeverity("error");
// //                 setSnackbarOpen(true);
// //                 return;
// //               }
// //               return axios.post(
// //                 `${process.env.REACT_APP_API_BASE_URL}/Drug`,
// //                 {
// //                   MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE,
// //                   MDD_DOSAGE: "Daily",
// //                   MDD_TAKES: prescription.MDD_TAKES,
// //                   MDD_CREATED_BY: formData.MTD_CREATED_BY,
// //                   MDD_CREATED_DATE: new Date().toISOString(),
// //                   MDD_UPDATED_BY: "",
// //                   MDD_UPDATED_DATE: null,
// //                   MDD_PATIENT_CODE: patientId,
// //                   MDD_RATE: prescription.MMC_RATE || 0,
// //                   MDD_STATUS: "",
// //                   MDD_SERIAL_NO: serial_no, // Use the serial_no from treatment response
// //                   MDD_QUANTITY: prescription.MDD_QUANTITY || 0,
// //                   MDD_AMOUNT:
// //                     prescription.MMC_RATE * (prescription.MDD_QUANTITY || 0),
// //                 }
// //               );
// //             }
// //             return null;
// //           }
// //         );
// //         await Promise.all(
// //           drugDetailsPromises.filter((promise) => promise !== null)
// //         );
// //       }
// //       // Navigate to view record with both patientId and serial_no
// //       navigate(`/dashboard/view-record/${patientId}/${serial_no}`, {
// //         state: {
// //           message: "Treatment created successfully!",
// //           serialNumber: serial_no
// //         }
// //       });
// //     }
// //   } catch (error) {
// //     console.error(
// //       "Error submitting record:",
// //       error.response?.data || error.message
// //     );
// //     setSnackbarMessage("Error submitting treatment and prescription details.");
// //     setSnackbarSeverity("error");
// //     setSnackbarOpen(true);
// //   } finally {
// //     setLoading(false);
// //   }
// // };

// const handleSubmit = async (e) => {
//   e.preventDefault();
//   setLoading(true);

//   const preparedPrescriptions = prescriptions.map((prescription) => ({
//     ...prescription,
//     MDD_TAKES:
//       prescription.MDD_TAKES === "other"
//         ? prescription.MDD_TAKES_CUSTOM
//         : prescription.MDD_TAKES,
//   }));

//   try {
//     if (isEditMode) {
//       // Your existing edit mode code...
//       try {
//         const updatePayload = {
//           Treatment: {
//             MTD_DOCTOR: formData.MTD_DOCTOR,
//             MTD_TYPE: formData.MTD_TYPE,
//             MTD_COMPLAIN: formData.MTD_COMPLAIN,
//             MTD_DIAGNOSTICS: formData.MTD_DIAGNOSTICS,
//             MTD_REMARKS: formData.MTD_REMARKS,
//             MTD_AMOUNT: formData.MTD_AMOUNT,
//             MTD_UPDATED_BY: Name,
//             MTD_TREATMENT_STATUS: formData.MTD_TREATMENT_STATUS,
//           },
//           Drugs: preparedPrescriptions.map((prescription) => ({
//             MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE,
//             MDD_QUANTITY: parseInt(prescription.MDD_QUANTITY) || 0,
//             MDD_RATE: prescription.MMC_RATE || prescription.MDD_RATE,
//             MDD_AMOUNT:
//               (parseFloat(prescription.MDD_RATE) || 0) *
//               (parseInt(prescription.MDD_QUANTITY) || 0) ||
//               parseFloat(prescription.MMC_RATE) ||
//               0,
//             MDD_DOSAGE: "",
//             MDD_TAKES: prescription.MDD_TAKES,
//             MDD_GIVEN_QUANTITY: 0,
//             MDD_STATUS: "",
//           })),
//         };

//         const response = await axios.post(
//           `${process.env.REACT_APP_API_BASE_URL}/Treatment/updatingtreatment/${patientId}/${serialNumber}`,
//           updatePayload
//         );

//         if (response.status === 200) {
//           setSnackbarMessage("Treatment updated successfully!");
//           setSnackbarSeverity("success");
//           setSnackbarOpen(true);
//           setTimeout(() => {
//             navigate(-1);
//           }, 1500);
//         } else {
//           setSnackbarMessage("Failed to update treatment.");
//           setSnackbarSeverity("error");
//           setSnackbarOpen(true);
//         }
//       } catch (error) {
//         setSnackbarMessage(
//           error.response?.data?.message || "Error updating treatment"
//         );
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       }
//     } else {
//       // CREATE NEW TREATMENT - FIXED VERSION
//       console.log("Creating new treatment with prescriptions:", preparedPrescriptions);

//       // First, create the treatment
//       const treatmentResponse = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/Treatment`,
//         {
//           ...formData,
//           MTD_APPOINMENT_ID: formData.MTD_APPOINMENT_ID || null
//         }
//       );

//       // Extract the serial number from the response
//       const serial_no = treatmentResponse.data.SerialNo || treatmentResponse.data.MTD_SERIAL_NO;
//       console.log("Treatment created with serial no:", serial_no);

//       if (!serial_no) {
//         throw new Error("Serial number not received from treatment creation");
//       }

//       // Create prescriptions if any valid ones exist
//       const validPrescriptions = preparedPrescriptions.filter(
//         prescription => prescription.MDD_MATERIAL_CODE && prescription.MDD_MATERIAL_CODE.trim() !== ""
//       );

//       console.log("Valid prescriptions to save:", validPrescriptions);

//       if (validPrescriptions.length > 0) {
//         try {
//           // Use Promise.all to save all prescriptions concurrently
//           const drugCreationPromises = validPrescriptions.map(async (prescription) => {
//             console.log("Creating drug for:", prescription.MDD_MATERIAL_NAME);

//             const drugPayload = {
//               MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE,
//               MDD_MATERIAL_NAME: prescription.MDD_MATERIAL_NAME,
//               MDD_DOSAGE: prescription.MDD_DOSAGE || "Daily",
//               MDD_TAKES: prescription.MDD_TAKES,
//               MDD_CREATED_BY: formData.MTD_CREATED_BY,
//               MDD_CREATED_DATE: new Date().toISOString(),
//               MDD_UPDATED_BY: "",
//               MDD_UPDATED_DATE: null,
//               MDD_PATIENT_CODE: patientId,
//               MDD_RATE: prescription.MMC_RATE || 0,
//               MDD_STATUS: "A", // Active status
//               MDD_SERIAL_NO: serial_no,
//               MDD_QUANTITY: parseInt(prescription.MDD_QUANTITY) || 0,
//               MDD_AMOUNT: (prescription.MMC_RATE || 0) * (parseInt(prescription.MDD_QUANTITY) || 0),
//             };

//             console.log("Drug payload:", drugPayload);

//             const response = await axios.post(
//               `${process.env.REACT_APP_API_BASE_URL}/Drug`,
//               drugPayload
//             );

//             console.log("Drug creation response:", response.data);
//             return response.data;
//           });

//           // Wait for all prescriptions to be created
//           const drugResults = await Promise.all(drugCreationPromises);
//           console.log("All drugs created successfully:", drugResults);

//           setSnackbarMessage(`Treatment created successfully with ${validPrescriptions.length} prescription(s)!`);
//           setSnackbarSeverity("success");
//           setSnackbarOpen(true);

//         } catch (drugError) {
//           console.error("Error creating drugs:", drugError);
//           setSnackbarMessage(`Treatment created but failed to save some prescriptions: ${drugError.message}`);
//           setSnackbarSeverity("warning");
//           setSnackbarOpen(true);
//         }
//       } else {
//         setSnackbarMessage("Treatment created successfully with no prescriptions!");
//         setSnackbarSeverity("success");
//         setSnackbarOpen(true);
//       }

//       // Navigate to view record
//       navigate(`/dashboard/view-record/${patientId}/${serial_no}`, {
//         state: {
//           message: "Treatment created successfully!",
//           serialNumber: serial_no
//         }
//       });
//     }
//   } catch (error) {
//     console.error(
//       "Error submitting record:",
//       error.response?.data || error.message
//     );
//     setSnackbarMessage("Error submitting treatment and prescription details.");
//     setSnackbarSeverity("error");
//     setSnackbarOpen(true);
//   } finally {
//     setLoading(false);
//   }
// };

//   const closeModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleSnackbarClose = (event, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbarOpen(false);
//   };

//   return (
//     <Container maxWidth="xl">
//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={3000}
//         onClose={handleSnackbarClose}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//       >
//         <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>

//       <Box sx={{ my: 2 }}>
//         <Button
//           startIcon={<ArrowBack />}
//           onClick={() => navigate(-1)}
//           variant="outlined"
//           sx={{ mb: 2 }}
//         >
//           Back
//         </Button>

//         <StyledPaper elevation={3}>
//           <Box sx={{ display: "flex", alignItems: "center", mb: 2, justifyContent: "center" }}>
//             <MedicalServices color="primary" sx={{ fontSize: 40, mr: 2 }} />
//             <Typography variant="h4" color="primary" fontWeight={600} gutterBottom>
//               {isEditMode ? "Edit Treatment Details" : "Add Treatment Details"}
//             </Typography>
//           </Box>

//           {channelnumber && (
//             <Box sx={{ textAlign: "center", mb: 3 }}>
//               <Chip
//                 label={`Channel Number: ${channelnumber}`}
//                 color="primary"
//                 variant="outlined"
//                 avatar={<Avatar>#</Avatar>}
//               />
//             </Box>
//           )}

//           <Typography
//             variant="subtitle1"
//             color="text.secondary"
//             gutterBottom
//             sx={{ mb: 2, textAlign: "center", mt: -2 }}
//           >
//             Fill in the treatment and prescription information below.
//           </Typography>

//           <form onSubmit={handleSubmit}>
//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 Patient Complaint
//               </Typography>
//               <TextField
//                 fullWidth
//                 id="MTD_COMPLAIN"
//                 value={formData.MTD_COMPLAIN}
//                 onChange={handleFormChange}
//                 placeholder="Enter patient complaint"
//                 multiline
//                 rows={3}
//                 variant="outlined"
//               />
//             </Box>

//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 Diagnosis
//               </Typography>
//               <TextField
//                 fullWidth
//                 id="MTD_DIAGNOSTICS"
//                 value={formData.MTD_DIAGNOSTICS}
//                 onChange={handleFormChange}
//                 placeholder="Enter patient diagnosis details"

//                 multiline
//                 rows={3}
//                 variant="outlined"
//               />
//             </Box>

//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 <Healing sx={{ verticalAlign: "middle", mr: 1, color: "primary.main" }} />
//                 Prescriptions
//               </Typography>
//               <Divider sx={{ mb: 2 }} />

//               {prescriptions.map((prescription, index) => (
//                 <Paper key={index} elevation={2} sx={{ p: 2, mb: 2, position: "relative" }}>
//                   <Box
//                     sx={{
//                       display: "grid",
//                       gridTemplateColumns: {
//                         xs: "1fr",
//                         sm: "minmax(250px, 1fr) minmax(180px, 0.8fr) minmax(100px, 0.5fr) minmax(120px, 0.6fr) minmax(100px, 0.5fr)",
//                       },
//                       gap: 2,
//                       alignItems: "flex-end",
//                       mb: 2,
//                     }}
//                   >
//                     <Box sx={{ minWidth: 0, position: "relative" }}>
//                       <TextField
//                         fullWidth
//                         label="Search Medicine"
//                         name="MDD_MATERIAL_NAME"
//                         value={prescription.MDD_MATERIAL_NAME}
//                         onChange={(event) => handleSearchChange(index, event)}
//                         onFocus={() => setActivePrescriptionIndex(index)}
//                         disabled={prescription.isFetched}
//                         required={!isEditMode}
//                         sx={{
//                           minWidth: { xs: "100%", sm: 250 },
//                           "& .MuiInputBase-root": { height: 56 },
//                         }}
//                       />
//                       {activePrescriptionIndex === index && searchResults.length > 0 && (
//                         <Paper
//                           elevation={3}
//                           sx={{
//                             position: "absolute",
//                             zIndex: 10,
//                             width: { xs: "calc(100% - 32px)", sm: 250 },
//                             maxHeight: 200,
//                             overflow: "auto",
//                             mt: 1,
//                           }}
//                         >
//                           <List>
//                             {searchResults.map((medicine) => (
//                               <ListItem
//                                 key={medicine.MMC_MATERIAL_CODE}
//                                 button
//                                 onClick={() =>
//                                   handleSelectMedicine(
//                                     index,
//                                     medicine.MMC_MATERIAL_CODE,
//                                     medicine.MMC_DESCRIPTION,
//                                     medicine.MMC_RATE
//                                   )
//                                 }
//                               >
//                                 <ListItemText
//                                   primary={medicine.MMC_DESCRIPTION}
//                                   secondary={`Code: ${medicine.MMC_MATERIAL_CODE} | Rate: $${medicine.MMC_RATE}`}
//                                 />
//                               </ListItem>
//                             ))}
//                           </List>
//                         </Paper>
//                       )}
//                     </Box>

//                     <Box>
//                       <TextField
//                         fullWidth
//                         type="number"
//                         name="MDD_QUANTITY"
//                         label="Quantity"
//                         value={prescription.MDD_QUANTITY}
//                         onChange={(event) => handlePrescriptionChange(index, event)}
//                         required={!isEditMode}
//                         inputProps={{ min: "1" }}
//                         sx={{
//                           minWidth: 100,
//                           "& .MuiInputBase-root": { height: 56 },
//                         }}
//                       />
//                     </Box>

//                     <Box>
//                       <Button
//                         startIcon={<Delete />}
//                         onClick={() => handleRemovePrescription(index)}
//                         color="error"
//                         variant="outlined"
//                         fullWidth
//                         sx={{
//                           minWidth: 120,
//                           height: 56,
//                           "& .MuiButton-startIcon": { marginRight: "8px" },
//                         }}
//                       >
//                         Remove
//                       </Button>
//                     </Box>

//                     {index === prescriptions.length - 1 && (
//                       <Box>
//                         <Button
//                           startIcon={<Add />}
//                           onClick={handleAddPrescription}
//                           variant="outlined"
//                           color="primary"
//                           fullWidth
//                           sx={{
//                             minWidth: 100,
//                             height: 56,
//                             "& .MuiButton-startIcon": { marginRight: "8px" },
//                           }}
//                         >
//                           Add
//                         </Button>
//                       </Box>
//                     )}
//                   </Box>
//                 </Paper>
//               ))}

//               {prescriptions.length === 0 && (
//                 <Button
//                   startIcon={<Add />}
//                   onClick={handleAddPrescription}
//                   variant="outlined"
//                   color="primary"
//                   sx={{
//                     mt: 1,
//                     minWidth: 200,
//                     height: 56,
//                     "& .MuiButton-startIcon": { marginRight: "8px" },
//                   }}
//                 >
//                   Add Medicine
//                 </Button>
//               )}
//             </Box>

//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 Doctor's Remarks
//               </Typography>
//               <TextField
//                 fullWidth
//                 id="MTD_REMARKS"
//                 value={formData.MTD_REMARKS}
//                 onChange={handleFormChange}
//                 placeholder="Enter doctor remarks for the patient"
//                 multiline
//                 rows={3}
//                 variant="outlined"
//               />
//             </Box>

//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" gutterBottom>
//                 Treatment Status
//               </Typography>
//               <FormControl fullWidth>
//                 <InputLabel>Treatment Status</InputLabel>
//                 <Select
//                   name="MTD_TREATMENT_STATUS"
//                   id="MTD_TREATMENT_STATUS"
//                   value={formData.MTD_TREATMENT_STATUS}
//                   onChange={handleFormChange}
//                   required
//                   label="Treatment Status"
//                 >

//                   <MenuItem value="C">Completed</MenuItem>
//                   <MenuItem value="P">Preparation completed</MenuItem>
//                   <MenuItem value="G">Invoice Generated</MenuItem>
//                 </Select>
//               </FormControl>
//             </Box>

//             <Box sx={{ mb: 4 }}>
//               <Typography variant="h6" gutterBottom>
//                 Treatment Amount
//               </Typography>
//               <TextField
//                 fullWidth
//                 type="number"
//                 id="MTD_AMOUNT"
//                 name="MTD_AMOUNT"
//                 label="Amount"
//                 value={formData.MTD_AMOUNT}
//                 onChange={handleFormChange}
//                 placeholder="Enter treatment amount"
//                 required
//                 inputProps={{ min: "1" }}
//                 InputProps={{
//                   startAdornment: (
//                     <MonetizationOn color="action" sx={{ mr: 1, color: "primary.main" }} />
//                   ),
//                 }}
//               />
//             </Box>

//             <Box sx={{ display: "flex", justifyContent: "center" }}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size="large"
//                 disabled={!(role === "Admin" || role === "Doc") || loading}
//                 startIcon={
//                   loading ? (
//                     <CircularProgress size={20} color="inherit" />
//                   ) : (
//                     <Description />
//                   )
//                 }
//                 sx={{ py: 1.5, px: 4, width: { xs: "100%", sm: 300 } }}
//               >
//                 {isEditMode ? "Update Treatment" : "Submit Treatment"}
//               </Button>
//             </Box>
//           </form>
//         </StyledPaper>
//       </Box>

//       <Dialog open={isModalOpen} onClose={closeModal}>
//         <DialogTitle>
//           {modalContent.includes("Error") ? "Error" : "Success"}
//         </DialogTitle>
//         <DialogContent>
//           <Typography>{modalContent}</Typography>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={closeModal} color="primary">
//             Close
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Container>
//   );
// };

// export default AddRecord;

import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  Divider,
  Chip,
  Avatar,
  Snackbar,
  Alert,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  ArrowBack,
  Add,
  Delete,
  MedicalServices,
  Healing,
  Description,
  MonetizationOn,
  CurrencyRupee,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: theme.shadows[2],
  [theme.breakpoints.up("sm")]: {
    padding: theme.spacing(3),
    boxShadow: theme.shadows[3],
  },
}));

const ResponsiveButton = styled(Button)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
    minWidth: 120,
  },
}));

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

const AddRecord = () => {
  const { patientId } = useParams();
  const Name = localStorage.getItem("Name");
  const location = useLocation();
  const { appoinmentid, channelnumber, MTD_APPOINMENT_ID, serialNumber } =
    location.state || {};
  const [searchResults, setSearchResults] = useState([]);
  const [patientError, setPatientError] = useState("");
  const [patientdetails, setPatientdetails] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const role = localStorage.getItem("Role");
  const [activePrescriptionIndex, setActivePrescriptionIndex] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  // Cache for medicines data
  const [medicineCache, setMedicineCache] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const [fetchLoading, setFetchLoading] = useState(false);

  // Responsive breakpoints
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [prescriptions, setPrescriptions] = useState([
    {
      MDD_MATERIAL_CODE: "",
      MDD_MATERIAL_NAME: "",
      MDD_DOSAGE: "",
      MDD_TAKES: "Daily",
      MDD_TAKES_CUSTOM: "",
      MDD_QUANTITY: "",
      MMC_RATE: 0,
    },
  ]);

  const [formData, setFormData] = useState({
    MTD_PATIENT_CODE: patientId,
    MTD_DATE: new Date().toISOString(),
    MTD_TYPE: "",
    MTD_DOCTOR: Name || "",
    MTD_COMPLAIN: "",
    MTD_DIAGNOSTICS: "",
    MTD_REMARKS: "",
    MTD_AMOUNT: 0 ,
    MTD_PAYMENT_STATUS: "",
    MTD_TREATMENT_STATUS: "P",
    MTD_SMS_STATUS: "",
    MTD_SMS: "",
    MTD_MEDICAL_STATUS: "",
    MTD_STATUS: "",
    MTD_CREATED_BY: Name || "",
    MTD_CREATED_DATE: new Date().toISOString(),
    MTD_UPDATED_BY: "",
    MTD_CHANNEL_NO: channelnumber || null,
    MTD_UPDATED_DATE: null,
    MTD_APPOINMENT_ID: MTD_APPOINMENT_ID || appoinmentid || null,
  });

  // Search medicines function
  const searchMedicines = useCallback(
    async (query) => {
      if (!query || query.length < 3) {
        setSearchResults([]);
        return;
      }

      try {
        let medicines = medicineCache;

        if (!medicines) {
          const response = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/material/active`
            // `https://testbackendaura.dockyardsoftware.com/api/material/active`
          );
          medicines = response.data;
          setMedicineCache(medicines);
        }

        const q = query.toLowerCase();
        const filtered = medicines.filter(
          (medicine) =>
            medicine.MMC_DESCRIPTION?.toLowerCase().includes(q) ||
            medicine.MMC_MATERIAL_SPEC?.toLowerCase().includes(q)
        );

        setSearchResults(filtered);
      } catch (error) {
        console.error("Error fetching materials:", error);
        setSearchResults([]);
      }
    },
    [medicineCache]
  );

  // Effect for debounced search
  useEffect(() => {
    if (debouncedSearchQuery) {
      searchMedicines(debouncedSearchQuery);
    } else {
      setSearchResults([]);
    }
  }, [debouncedSearchQuery, searchMedicines]);

  const handleFormChange = (e) => {
    const { name, value, id } = e.target;
    const fieldName = name || id;

    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  const handleAmountChange = (e) => {
  const value = e.target.value;
  setFormData((prevData) => ({
    ...prevData,
    MTD_AMOUNT: value === "" || value === null ? 0 : parseFloat(value) || 0,
  }));
};

  const handlePrescriptionChange = (index, event) => {
    const { name, value } = event.target;
    const values = [...prescriptions];

    if (name === "MDD_TAKES") {
      values[index][name] = value;
      if (value !== "other") {
        values[index].MDD_TAKES_CUSTOM = "";
      }
    } else if (name === "MDD_TAKES_CUSTOM") {
      values[index][name] = value;
    } else {
      values[index][name] = value;
    }

    setPrescriptions(values);
  };

  const handleSearchChange = (index, event) => {
    const query = event.target.value;
    const values = [...prescriptions];
    values[index].MDD_MATERIAL_NAME = query;
    setPrescriptions(values);
    setSearchQuery(query);
    setActivePrescriptionIndex(index);
  };

  const handleAddPrescription = () => {
    setPrescriptions([
      ...prescriptions,
      {
        MDD_MATERIAL_CODE: "",
        MDD_MATERIAL_NAME: "",
        MDD_DOSAGE: "",
        MDD_TAKES: "Daily",
        MDD_TAKES_CUSTOM: "",
        MDD_QUANTITY: "",
        MMC_RATE: 0,
      },
    ]);
  };

  const handleSelectMedicine = (index, materialCode, materialName, rate) => {
    const values = [...prescriptions];
    values[index].MDD_MATERIAL_CODE = materialCode;
    values[index].MDD_MATERIAL_NAME = materialName;
    values[index].MMC_RATE = rate;
    setSearchResults([]);
    setSearchQuery("");
    setPrescriptions(values);
  };

  const handleRemovePrescription = async (index) => {
    const values = [...prescriptions];
    const removedPrescription = values[index];
    values.splice(index, 1);
    setPrescriptions(values);

    if (isEditMode && removedPrescription.MDD_MATERIAL_CODE) {
      try {
        await axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/Drug/drugstatusupdate`,
          null,
          {
            params: {
              patientCode: removedPrescription.MDD_PATIENT_CODE,
              serialNo: removedPrescription.MDD_SERIAL_NO,
              materialCode: removedPrescription.MDD_MATERIAL_CODE,
            },
          }
        );
        console.log('Drug / Service status updated to "I"');
      } catch (error) {
        console.error("Error updating Drug / Service status:", error);
      }
    }
  };

  // Enhanced data fetching for edit mode
  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchExistingData = async () => {
      if (serialNumber) {
        setIsEditMode(true);
        setFetchLoading(true);

        try {
          const treatmentResponse = await axios.get(
            `${process.env.REACT_APP_API_BASE_URL}/Treatment/patientdetail/treatmentdetail/${patientId}/${serialNumber}`
          );

          const treatmentData = treatmentResponse.data;

          setFormData((prevData) => ({
            ...prevData,
            MTD_DOCTOR: treatmentData.MTD_DOCTOR || Name || "",
            MTD_TYPE: treatmentData.MTD_TYPE || "",
            MTD_COMPLAIN: treatmentData.MTD_COMPLAIN || "",
            MTD_DIAGNOSTICS: treatmentData.MTD_DIAGNOSTICS || "",
            MTD_REMARKS: treatmentData.MTD_REMARKS || "",
            MTD_AMOUNT: treatmentData.MTD_AMOUNT || 0 ,
            MTD_TREATMENT_STATUS: treatmentData.MTD_TREATMENT_STATUS || "P",
            MTD_DATE: treatmentData.MTD_DATE || new Date().toISOString(),
          }));

          try {
            const prescriptionsResponse = await axios.get(
              `${process.env.REACT_APP_API_BASE_URL}/Drug/${serialNumber}`
            );

            if (
              prescriptionsResponse.data &&
              prescriptionsResponse.data.length > 0
            ) {
              const formattedPrescriptions = prescriptionsResponse.data.map(
                (prescription) => ({
                  MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE || "",
                  MDD_MATERIAL_NAME:
                    prescription.MDD_MATERIAL_NAME ||
                    prescription.MMC_DESCRIPTION ||
                    "",
                  MDD_DOSAGE: prescription.MDD_DOSAGE || "",
                  MDD_TAKES: prescription.MDD_TAKES || "Daily",
                  MDD_TAKES_CUSTOM:
                    prescription.MDD_TAKES === "other"
                      ? prescription.MDD_TAKES
                      : "",
                  MDD_QUANTITY: prescription.MDD_QUANTITY?.toString() || "1",
                  MMC_RATE: prescription.MMC_RATE || prescription.MDD_RATE || 0,
                  MDD_SERIAL_NO: prescription.MDD_SERIAL_NO,
                  MDD_PATIENT_CODE: prescription.MDD_PATIENT_CODE,
                })
              );
              setPrescriptions(formattedPrescriptions);
            }
          } catch (prescriptionError) {
            console.error("Error fetching prescriptions:", prescriptionError);
            setSnackbarMessage(
              "Error loading prescriptions, but you can continue editing."
            );
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
          }
        } catch (error) {
          console.error("Error fetching treatment data:", error);
          setPatientError("Unable to load treatment details.");
          setSnackbarMessage("Failed to load existing treatment data.");
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        } finally {
          setFetchLoading(false);
        }
      }
    };

    fetchExistingData();
  }, [serialNumber, patientId, Name]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const preparedPrescriptions = prescriptions.map((prescription) => ({
      ...prescription,
      MDD_TAKES:
        prescription.MDD_TAKES === "other"
          ? prescription.MDD_TAKES_CUSTOM
          : prescription.MDD_TAKES,
    }));

    try {
      if (isEditMode) {
        // Your existing edit mode code...
        try {
          const updatePayload = {
            Treatment: {
              MTD_DOCTOR: formData.MTD_DOCTOR,
              MTD_TYPE: formData.MTD_TYPE,
              MTD_COMPLAIN: formData.MTD_COMPLAIN,
              MTD_DIAGNOSTICS: formData.MTD_DIAGNOSTICS,
              MTD_REMARKS: formData.MTD_REMARKS,
              MTD_AMOUNT: formData.MTD_AMOUNT ?? 0,
              MTD_UPDATED_BY: Name,
              MTD_TREATMENT_STATUS: formData.MTD_TREATMENT_STATUS,
            },
            Drugs: preparedPrescriptions.map((prescription) => ({
              MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE,
              MDD_QUANTITY: parseInt(prescription.MDD_QUANTITY) || 0,
              MDD_RATE: prescription.MMC_RATE || prescription.MDD_RATE,
              MDD_AMOUNT:
                (parseFloat(prescription.MDD_RATE) || 0) *
                  (parseInt(prescription.MDD_QUANTITY) || 0) ||
                parseFloat(prescription.MMC_RATE) ||
                0,
              MDD_DOSAGE: "",
              MDD_TAKES: prescription.MDD_TAKES,
              MDD_GIVEN_QUANTITY: 0,
              MDD_STATUS: "",
            })),
          };

          const response = await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/Treatment/updatingtreatment/${patientId}/${serialNumber}`,
            updatePayload
          );

          if (response.status === 200) {
            setSnackbarMessage("Treatment updated successfully!");
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
            setTimeout(() => {
              navigate(-1);
            }, 1500);
          }
        } catch (error) {
          setSnackbarMessage(
            error.response?.data?.message || "Error updating treatment"
          );
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } else {
        // CREATE NEW TREATMENT
        const treatmentResponse = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Treatment`,
          {
            ...formData,
            MTD_APPOINMENT_ID: formData.MTD_APPOINMENT_ID || null,
          }
        );

        const serial_no =
          treatmentResponse.data.SerialNo ||
          treatmentResponse.data.MTD_SERIAL_NO;

        if (!serial_no) {
          throw new Error("Serial number not received from treatment creation");
        }

        const validPrescriptions = preparedPrescriptions.filter(
          (prescription) =>
            prescription.MDD_MATERIAL_CODE &&
            prescription.MDD_MATERIAL_CODE.trim() !== ""
        );

        if (validPrescriptions.length > 0) {
          try {
            const drugCreationPromises = validPrescriptions.map(
              async (prescription) => {
                const drugPayload = {
                  MDD_MATERIAL_CODE: prescription.MDD_MATERIAL_CODE,
                  MDD_MATERIAL_NAME: prescription.MDD_MATERIAL_NAME,
                  MDD_DOSAGE: prescription.MDD_DOSAGE || "Daily",
                  MDD_TAKES: prescription.MDD_TAKES,
                  MDD_CREATED_BY: formData.MTD_CREATED_BY,
                  MDD_CREATED_DATE: new Date().toISOString(),
                  MDD_UPDATED_BY: "",
                  MDD_UPDATED_DATE: null,
                  MDD_PATIENT_CODE: patientId,
                  MDD_RATE: prescription.MMC_RATE || 0,
                  MDD_STATUS: "A",
                  MDD_SERIAL_NO: serial_no,
                  MDD_QUANTITY: parseInt(prescription.MDD_QUANTITY) || 0,
                  MDD_AMOUNT:
                    (prescription.MMC_RATE || 0) *
                    (parseInt(prescription.MDD_QUANTITY) || 0),
                };

                const response = await axios.post(
                  `${process.env.REACT_APP_API_BASE_URL}/Drug`,
                  drugPayload
                );
                return response.data;
              }
            );

            await Promise.all(drugCreationPromises);
            setSnackbarMessage(
              `Treatment created successfully with ${validPrescriptions.length} prescription(s)!`
            );
            setSnackbarSeverity("success");
            setSnackbarOpen(true);
          } catch (drugError) {
            console.error("Error creating drugs:", drugError);
            setSnackbarMessage(
              `Treatment created but failed to save some prescriptions: ${drugError.message}`
            );
            setSnackbarSeverity("warning");
            setSnackbarOpen(true);
          }
        } else {
          setSnackbarMessage(
            "Treatment created successfully with no prescriptions!"
          );
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        }

        navigate(`/dashboard/view-record/${patientId}/${serial_no}`, {
          state: {
            message: "Treatment created successfully!",
            serialNumber: serial_no,
          },
        });
      }
    } catch (error) {
      console.error(
        "Error submitting record:",
        error.response?.data || error.message
      );
      setSnackbarMessage(
        "Error submitting treatment and prescription details."
      );
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbarOpen(false);
  };

  return (
    <Container
      maxWidth="lg"
      sx={{ py: isMobile ? 1 : 2, px: isMobile ? 1 : 2 }}
    >
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box sx={{ my: isMobile ? 1 : 2 }}>
        <ResponsiveButton
          startIcon={<ArrowBack />}
          onClick={() => navigate(-1)}
          variant="outlined"
          sx={{ mb: 2 }}
        >
          {isMobile ? "Back" : "Go Back"}
        </ResponsiveButton>

        <StyledPaper elevation={3}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
              justifyContent: "center",
              flexDirection: isMobile ? "column" : "row",
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <MedicalServices
              color="primary"
              sx={{
                fontSize: isMobile ? 30 : 40,
                mr: isMobile ? 0 : 2,
                mb: isMobile ? 1 : 0,
              }}
            />
            <Typography
              variant={isMobile ? "h5" : "h4"}
              color="primary"
              fontWeight={600}
              gutterBottom
            >
              {isEditMode ? "Edit Treatment Details" : "Add Treatment Details"}
            </Typography>
          </Box>

          {channelnumber && (
            <Box sx={{ textAlign: "center", mb: 3 }}>
              <Chip
                label={`Channel: ${channelnumber}`}
                color="primary"
                variant="outlined"
                avatar={<Avatar>#</Avatar>}
                size={isMobile ? "small" : "medium"}
              />
            </Box>
          )}

          <Typography
            variant={isMobile ? "body2" : "subtitle1"}
            color="text.secondary"
            gutterBottom
            sx={{ mb: 2, textAlign: "center" }}
          >
            Fill in the treatment and prescription information below.
          </Typography>

          <form onSubmit={handleSubmit}>
            {/* Patient Complaint */}
            <Box sx={{ mb: 3 }}>
              <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
                Patient Complaint
              </Typography>
              <TextField
                fullWidth
                id="MTD_COMPLAIN"
                value={formData.MTD_COMPLAIN}
                onChange={handleFormChange}
                placeholder="Enter patient complaint"
                multiline
                rows={isMobile ? 2 : 3}
                variant="outlined"
                size={isMobile ? "small" : "medium"}
              />
            </Box>

            {/* Diagnosis */}
            <Box sx={{ mb: 3 }}>
              <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
                Diagnosis
              </Typography>
              <TextField
                fullWidth
                id="MTD_DIAGNOSTICS"
                value={formData.MTD_DIAGNOSTICS}
                onChange={handleFormChange}
                placeholder="Enter patient diagnosis details"
                multiline
                rows={isMobile ? 2 : 3}
                variant="outlined"
                size={isMobile ? "small" : "medium"}
              />
            </Box>

            {/* Prescriptions Section */}
            <Box sx={{ mb: 3 }}>
              <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
                <Healing
                  sx={{
                    verticalAlign: "middle",
                    mr: 1,
                    color: "primary.main",
                    fontSize: isMobile ? 20 : 24,
                  }}
                />
                Prescriptions
              </Typography>
              <Divider sx={{ mb: 2 }} />

             {prescriptions.map((prescription, index) => (
  <Paper key={index} elevation={1} sx={{ p: 2, mb: 2, position: "relative" }}>
    <Box sx={{ 
      display: "flex", 
      flexDirection: isMobile ? "column" : "row",
      gap: 2,
      alignItems: isMobile ? "stretch" : "flex-end"
    }}>
      {/* Medicine Search - Wrapped in relative container */}
      <Box sx={{ 
        flex: isMobile ? "1 1 auto" : "2 1 0",
        minWidth: 0,
        position: "relative" // Important for dropdown positioning
      }}>
        <TextField
          fullWidth
          label="Search Drug / Service"
          name="MDD_MATERIAL_NAME"
          value={prescription.MDD_MATERIAL_NAME}
          onChange={(event) => handleSearchChange(index, event)}
          onFocus={() => setActivePrescriptionIndex(index)}
          onBlur={() => setTimeout(() => setActivePrescriptionIndex(null), 200)} // Delay to allow click
          required={!isEditMode}
          size={isMobile ? "small" : "medium"}
        />
        
        {/* Enhanced Dropdown */}
        {activePrescriptionIndex === index && searchResults.length > 0 && (
          <Paper
            elevation={8}
            sx={{
              position: "absolute",
              zIndex: 9999, // Very high z-index to ensure it's on top
              width: "100%",
              maxHeight: isMobile ? 150 : 200,
              overflow: "auto",
              mt: 0.5,
              top: "100%",
              left: 0,
              backgroundColor: "background.paper",
              border: 1,
              borderColor: "divider",
            }}
          >
            <List dense>
              {searchResults.map((medicine) => (
                <ListItem
                  key={medicine.MMC_MATERIAL_CODE}
                  button
                  onClick={() =>
                    handleSelectMedicine(
                      index,
                      medicine.MMC_MATERIAL_CODE,
                      medicine.MMC_DESCRIPTION,
                      medicine.MMC_RATE
                    )
                  }
                  sx={{
                    py: isMobile ? 1.5 : 1,
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    "&:last-child": {
                      borderBottom: "none"
                    },
                    "&:hover": {
                      backgroundColor: "primary.light",
                      color: "primary.contrastText",
                    }
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          fontWeight: 600,
                          fontSize: isMobile ? "0.875rem" : "0.9rem"
                        }}
                      >
                        {medicine.MMC_DESCRIPTION}
                      </Typography>
                    }
                    secondary={
                      <Typography variant="caption" sx={{ opacity: 0.8 }}>
                        Code: {medicine.MMC_MATERIAL_CODE} | Rate: LKR {medicine.MMC_RATE}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </Box>

      {/* Quantity */}
      <Box sx={{ 
        flex: isMobile ? "1 1 auto" : "1 1 0",
        minWidth: isMobile ? "auto" : 100
      }}>
        <TextField
          fullWidth
          type="number"
          name="MDD_QUANTITY"
          label="Quantity"
          value={prescription.MDD_QUANTITY}
          onChange={(event) => handlePrescriptionChange(index, event)}
          required={!isEditMode}
          inputProps={{ min: "1" }}
          size={isMobile ? "small" : "medium"}
        />
      </Box>

      {/* Action Buttons */}
      <Box sx={{ 
        display: "flex", 
        gap: 1,
        flexDirection: isMobile ? "row" : "column",
        width: isMobile ? "100%" : "auto"
      }}>
        <Button
          startIcon={<Delete />}
          onClick={() => handleRemovePrescription(index)}
          color="error"
          variant="outlined"
          size={isMobile ? "small" : "medium"}
          sx={{ 
            flex: 1,
            minWidth: isMobile ? "auto" : 120 
          }}
        >
          {isMobile ? "" : "Remove"}
        </Button>

        {index === prescriptions.length - 1 && (
          <Button
            startIcon={<Add />}
            onClick={handleAddPrescription}
            variant="outlined"
            color="primary"
            size={isMobile ? "small" : "medium"}
            sx={{ 
              flex: 1,
              minWidth: isMobile ? "auto" : 120 
            }}
          >
            {isMobile ? "" : "Add More"}
          </Button>
        )}
      </Box>
    </Box>
  </Paper>
))}
              {prescriptions.length === 0 && (
                <ResponsiveButton
                  startIcon={<Add />}
                  onClick={handleAddPrescription}
                  variant="outlined"
                  color="primary"
                  sx={{ mt: 1 }}
                  size={isMobile ? "small" : "medium"}
                >
                  Add
                </ResponsiveButton>
              )}
            </Box>

            {/* Doctor's Remarks */}
            <Box sx={{ mb: 3 }}>
              <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
                Doctor's Remarks
              </Typography>
              <TextField
                fullWidth
                id="MTD_REMARKS"
                value={formData.MTD_REMARKS}
                onChange={handleFormChange}
                placeholder="Enter doctor remarks for the patient"
                multiline
                rows={isMobile ? 2 : 3}
                variant="outlined"
                size={isMobile ? "small" : "medium"}
              />
            </Box>

            {/* Treatment Status */}
            <Box sx={{ mb: 3 }}>
              <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
                Treatment Status
              </Typography>
              <FormControl fullWidth size={isMobile ? "small" : "medium"}>
                <InputLabel>Treatment Status</InputLabel>
                <Select
                  name="MTD_TREATMENT_STATUS"
                  id="MTD_TREATMENT_STATUS"
                  value={formData.MTD_TREATMENT_STATUS}
                  onChange={handleFormChange}
                  required
                  label="Treatment Status"
                >
                  <MenuItem value="C">Completed</MenuItem>
                  <MenuItem value="P">Preparation completed</MenuItem>
                  <MenuItem value="G">Invoice Generated</MenuItem>
                </Select>
              </FormControl>
            </Box>

            {/* Treatment Amount */}
            <Box sx={{ mb: 4 }}>
              <Typography variant={isMobile ? "subtitle1" : "h6"} gutterBottom>
                Service Charge 1
              </Typography>
              <TextField
                fullWidth
                type="number"
                id="MTD_AMOUNT"
                name="MTD_AMOUNT"
                label="Amount (LKR)"
                value={formData.MTD_AMOUNT}
                onChange={handleAmountChange}
                placeholder="Enter Service 1 amount"
                // required
                size={isMobile ? "small" : "medium"}
                // InputProps={{
                //   startAdornment: (
                //     <  color="action" sx={{
                //       mr: 1,
                //       color: "primary.main",
                //       fontSize: isMobile ? 18 : 24
                //     }} />
                //   ),
                // }}
              />
            </Box>

            {/* Submit Button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: isMobile ? "column" : "row",
                gap: isMobile ? 1 : 0,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? "medium" : "large"}
                disabled={!(role === "Admin" || role === "Doc") || loading}
                startIcon={
                  loading ? (
                    <CircularProgress
                      size={isMobile ? 16 : 20}
                      color="inherit"
                    />
                  ) : (
                    <Description />
                  )
                }
                sx={{
                  py: isMobile ? 1 : 1.5,
                  px: isMobile ? 2 : 4,
                  width: isMobile ? "100%" : "auto",
                  minWidth: isMobile ? "auto" : 300,
                }}
              >
                {isEditMode ? "Update Treatment" : "Submit Treatment"}
              </Button>
            </Box>
          </form>
        </StyledPaper>
      </Box>

      <Dialog
        open={isModalOpen}
        onClose={closeModal}
        fullScreen={isMobile}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {modalContent.includes("Error") ? "Error" : "Success"}
        </DialogTitle>
        <DialogContent>
          <Typography variant={isMobile ? "body2" : "body1"}>
            {modalContent}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeModal}
            color="primary"
            size={isMobile ? "small" : "medium"}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AddRecord;
